import React from 'react'
import { Link } from 'react-router-dom';
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowDropleft } from "react-icons/io";
import { BsInfoSquare } from "react-icons/bs";
import { GrDatabase } from "react-icons/gr";
import { RiMobileDownloadFill } from "react-icons/ri";
import { FaSearch } from "react-icons/fa";



function DynamicComponentforDatewise({Title}) {
    return (
        <>
            <div className='  dark:bg-[#121519]  min-h-screen px-4'>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1 gap-2 '>
                    
                    <div>
                        <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>{Title}</h1>
                        </div>
                </div>
                <div className='w-[100%] flex justify-end items-center'>
                    <div className='bg-[rgb(237,237,237)] p-[9px] border-l-[0.25rem] border-black w-full sm:w-[400px]  flex items-center "'>
                        <BsInfoSquare />
                        <span className='text-[12px] ml-2 text-red-600 italic'> Please-note: Reports are available for max.30 days period.</span>
                    </div>
                </div>
                <div className='w-[100%] flex flex-wrap gap-4'>

                    <div className='w-full sm:w-[48%] md:w-[31%] lg:w-[18%] flex flex-col gap-1'>
                        <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Date Range</label>
                        <input className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-[#fff]' type="Date" />
                    </div>
                    <div className='w-full sm:w-[48%] md:w-[31%] lg:w-[24%] flex flex-col gap-1'>
                        <label className='text-[#000] text-[12px] font-semibold dark:text-[#fff]'>Search Username</label>
                        <input className='text-[#454546] border-[#d4cfcf] border-[1px] rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:text-[#fff] dark:bg-[#121519]'
                            placeholder='Enter UserName'
                            type="text" />
                    </div>

                    <div className='w-full sm:w-[48%] md:w-[31%] lg:w-[24%] flex items-center gap-1 mt-4'>
                        <button className='flex items-center justify-center border-[1px] border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-[#fff] w-full sm:w-auto'>
                            <FaSearch />
                            <span className='text-[12px] font-semibold'>Search</span>
                        </button>

                        <button className='flex items-center justify-center border-[1px] border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-[#fff] w-full sm:w-auto'>
                            <RiMobileDownloadFill />
                            <span className='text-[12px] font-semibold '>Download</span>
                        </button>
                    </div>

                </div>
            </div>
        </>
    )
}

export default DynamicComponentforDatewise
